<script>
import { mapActions, mapState } from 'pinia';
import { basketStore } from '../../stores/basket';
import { useModalStore } from '../../stores/modal';
import { langFunction as getLang } from '../utils/langFunction';
import FormCheckbox from './form/form-checkbox.vue';
import PopupConfirm from '@/components/order-vue/order/components/popups/popup-confirm.vue';
import OrderRegisterError from '@/components/order-vue/order/components/popups/order-register-error.vue';
import BasketErrors from '@/components/order-vue/order/components/basket-errors.vue';

export default {
	components: {
		BasketErrors,
		PopupConfirm,
		FormCheckbox,
		OrderRegisterError
	},
	inject: ['basketMode', 'orderMode', 'combinedMode'],
	data() {
		return {
			confirmClearBasketModalId: 'modal-cart-clear'
		};
	},
	computed: {
		...mapState(basketStore, {
			isBaskedEmpty: 'isEmpty',
			isBasketSelected: 'itemsSelected',
			isAllSelected: 'isAllSelected'
		}),
		isIndeterminate() {
			return !this.isAllSelected && this.isBasketSelected.length > 0;
		}
	},
	methods: {
		...mapActions(basketStore, [
			'removeSelectedItems', 
			'selectAllItems'
		]),

		...mapActions(useModalStore, [
			'openModal', 
			'closeModal'
		]),

		getLang,

		openConfirmPopup() {
			this.openModal(this.confirmClearBasketModalId);
		},
		onPopupConfirmClearBasket() {
			this.removeSelectedItems();
			this.closeModal();
		}
	}
};
</script>

<template>
	<hgroup class="template-page__hgroup">
		<h1 class="title-page title-page--equal-offset">{{ $loc.get('BASKET_TITLE') }}</h1>
		<BasketErrors class="template-page__hgroup-error"/>
		<OrderRegisterError class="template-page__hgroup-error"/>
	</hgroup>
	<div 
		v-if="!isBaskedEmpty && (!orderMode || combinedMode)" 
		class="cart-controls"
	>
		<FormCheckbox
			ref="selectAllCheckbox"
			:name="'callback-confirm'"
			:class-list="{
				'cart-controls__checkbox-button button button--secondary--gray button--checkbox' : true,
			}"
			v-model:model-value="isAllSelected"
			@update:model-value="selectAllItems"
		>
			<span class="form-checkbox__label">{{ $loc.get('BASKET_SELECT_ALL') }}</span>
		</FormCheckbox>
		<button 
			class="cart-controls__remove-button button button--secondary--gray" 
			type="button" 
			:disabled="isBasketSelected.length <= 0"
			@click="openConfirmPopup"
		>
			<i class="icon icon-trash"></i>
			<span>{{ $loc.get('BASKET_CLEAN') }}</span>
		</button>
	</div>

	<Teleport to="body">
		<PopupConfirm
			:popup-id="confirmClearBasketModalId"
			:popup-title="$loc.get('BASKET_CLEAN_POPUP_TITLE')"
			@confirm="onPopupConfirmClearBasket"
		>
			{{ $loc.get('BASKET_CLEAN_POPUP_TEXT') }}
		</PopupConfirm>
	</Teleport>
</template>

<style scoped>

</style>
